/** @jsx h */
import FilterRemoveAll from '../FilterRemoveAll';
import FilterFieldset from '../FilterFieldset';
import SearchInput from '../SearchInput';

const SearchHeaderEvents = ({
  query,
  pluginNamespace,
  showFacets,
  facets,
  facetsActive,
  sorting,
  triggerAjaxSubmit,
  searchType,
  showMaininput,
  restrictionFilters,
  resetFilters,
}) => {
  return (
    <div className="form form--search">
      {showMaininput && (
        <SearchInput
          query={query}
          pluginNamespace={pluginNamespace}
          triggerAjaxSubmit={triggerAjaxSubmit}
          resetFilters={resetFilters}
        />
      )}
      {showFacets &&
        facets.map(
          (facet, index) =>
            facet.options.length > 0 && (
              <FilterFieldset
                key={index}
                query={query}
                facet={facet}
                facetsActive={facetsActive}
                sorting={sorting}
                triggerAjaxSubmit={triggerAjaxSubmit}
                pluginNamespace={pluginNamespace}
              />
            )
        )}
      {showFacets && facets.length > 0 && (
        <FilterRemoveAll
          pluginNamespace={pluginNamespace}
          resetFilters={resetFilters}
        />
      )}
    </div>
  );
};

export default SearchHeaderEvents;
